export default __webpack_public_path__ + "static/media/jason_lam.0218da8a.jpg";